import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import nimble from "../assets/img/nimbleR.png";
import python from "../assets/img/certificates/python.png";
import numeric from "../assets/img/numeric.png";
import yoApp from "../assets/img/yoapp.png";
import myPay from "../assets/img/mypay.png";

import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { ImageCard } from "./ImageCard";

export const Projects = () => {
  const projects = [
    {
      title: "Nimble Clinical Research",
      description: "Software Developer",
      imgUrl: nimble,
      link: "https://nimble-cr.com",
    },
    {
      title: "Numeric Mind",
      description: "Frontend web developer",
      imgUrl: numeric,
      link: "https://numericmind.com",
    },
    {
      title: "Yo-App digital wallet",
      description: "Digital payment app",
      imgUrl: yoApp,
      link: "https://yoapp.com.np",
    },
    {
      title: "MyPay digital wallet",
      description: "Digital payment solution",
      imgUrl: myPay,
      link: "https://mypay.com.np",
    },
  ];

  const certificates = [
    {
      title: "Python",
      description: "Python Developer",
      imgUrl: python,
      // link: "https://nimble-cr.com",
    },
  ];
  const educations = [
    {
      title: "Florida Institute of Technology",
      description: "Computer Engineer",
      extra: "",
      imgUrl:
        "https://dsspvtltd.com/wp-content/uploads/2024/03/Florida-Tech-1080x675.jpg",
      link: "https://www.fit.edu/",
    },
    // {
    //   title: "Pokhara University",
    //   description: "Computer Engineer",
    //   imgUrl:
    //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3noCTjDvXMC0hTk4wqDW9gCSqjSKF20ylhA&s",
    //   link: "https://pu.edu.np/",
    // },
    // {
    //   title: "Kathmandu Model College",
    //   description: "Biology",
    //   imgUrl:
    //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVMhOw0NJObTVluFNXvxYrY89eXmoAzUV0mQ&s",
    //   link: "https://ktmmodelcollege.edu.np/",
    // },
  ];

  const academicAchievements = [
    "Computer Engineer",
    "GPA 3.8",
    "2 years work experience",
    "Volunteer & Exhibitions",
    "Work-Study Balance",
  ];

  function AcademicAchievementsCards() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {academicAchievements.map((achievement, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "15px",
              width: "200px",
              textAlign: "center",
            }}
          >
            {achievement}
          </div>
        ))}
      </div>
    );
  }

  return (
    <section className="project" id="experience">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Milestones</h2>
                  <p>Happy person</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Professional</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Academical</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Certificates</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <>
                          <Row>
                            <p>
                              Worked on diverse projects including a
                              feature-rich book e-commerce platform with a
                              recommendation system, a payment gateway
                              integration for seamless transactions, and a
                              clinical research data analytics application, all
                              developed using React for the frontend.
                            </p>
                          </Row>
                          <Row>
                            {projects.map((project, index) => {
                              return <ProjectCard key={index} {...project} />;
                            })}
                          </Row>
                        </>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {educations.map((project, index) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <ProjectCard key={index} {...project} />
                              </div>
                            );
                          })}
                        </Row>
                        <p>
                          Er. Sajina Pathak 👩‍💻 <br></br>
                          Currently a Graduate Student in Computer Engineer in
                          Florida Institute of Technology. <br></br>
                          Completed Bachelor's of Engineering in Information
                          Technology <br></br> <br></br>
                          Worked on book e-commerce platform with a
                          recommendation system, agricultural e-commerce
                          website, java android app for college projects
                          <br></br>
                          <br></br>
                          <br></br>
                          {AcademicAchievementsCards()}
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>
                          IT Engineer 👩‍💻 <br></br>
                          Work hard now so that one day you can relax and chill.
                          <br></br>
                          <br></br>
                          <br></br>
                        </p>
                        <Row>
                          <ImageCard images={certificates} />
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="IDK" src={colorSharp2}></img>
    </section>
  );
};
